<template>
  <div class="container">
    <div class="column">
      <div class="columns">
        <div @click="showImageModal(imageFoggia)" class="column is-3">
          <firebase-img :src="imageFoggia" style="max-width: 150px; max-height: 150px;" />
        </div>
        <div class="column is-5">
          <b-field horizontal :label="$translate('as_image') | capitalize">
            <b-checkbox v-model="asImage" @input="setDefaultSole" :disabled="disabledbool"></b-checkbox>
          </b-field>
          <b-field
            horizontal
            :label="$translate('foggia') | capitalize"
            :message="errors.first('fogge')"
            :type="{ 'is-danger': errors.has('fogge') }"
            Z
          >
            <b-select
              :disabled="asImage || disabledbool"
              v-validate="'required'"
              name="fogge"
              v-model="foggiaId"
              @input="updateSole({ foggia: { id: foggiaId } })"
            >
              <option v-for="foggia in availablefogge" :key="foggia.id" :value="foggia.id">
                {{ foggia.commercial_name }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field v-if="soleId" :label="$translate('addingchar') | capitalize">
            <div class="multiselect-list is-disabled">
              <div v-if="addingChar" class="multiselect-option is-selected">
                {{ addingChar }}
              </div>
              <span v-else class="has-text-grey-light multiselect-placeholder">
                {{ $translate('placeholder_select') | capitalize }}
              </span>
            </div>
          </b-field>
          <b-field v-else :label="$translate('addingchar') | capitalize">
            <div class="multiselect-list is-disabled">
              <div v-for="option in foggiaOptionalTagOptions" :key="option" class="multiselect-option">
                {{ option }}
              </div>
              <span v-if="!foggiaOptionalTagOptions.length" class="has-text-grey-light multiselect-placeholder">
                {{ $translate('placeholder_select') | capitalize }}
              </span>
            </div>
          </b-field>
        </div>
      </div>
      <hr class="green" />
      <input type="hidden" v-model="soleId" v-validate="'required'" name="sole" />
      <p v-if="errors.has('sole')" class="help is-danger">{{ $translate('sole_required') | capitalize }}</p>
      <div v-if="foggiaId">
        <div v-for="(treadData, treadName) in solesByTread" :key="treadName">
          <h1 class="subtitle">{{ treadName }}</h1>
          <firebase-img
            @click="showImageModal(treadData.image)"
            :src="treadData.image == null ? 'https://place-hold.it/100x100' : treadData.image"
            style="max-width: 100px; max-height: 100px;"
          />
          <br />
          <br />
          <br />
          <div v-for="sole in treadData.soles" :key="sole.id">
            <div class="columns">
              <div @click="showImageModal(sole.image)" class="column is-4">
                <firebase-img :src="sole.image" style="max-width: 150px; max-height: 75px;" />
              </div>
              <div class="column is-6">
                <div class="columns">
                  <div class="column">
                    {{ sole.commercial_name + '_' + sole.color.commercial_name }}
                  </div>
                  <div class="column is-1">
                    <b-field>
                      <b-radio
                        name="sole"
                        v-model="soleId"
                        @input="updateSole(sole)"
                        :disabled="disabledbool"
                        :native-value="sole.id"
                      >
                      </b-radio>
                    </b-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </div>
    <b-modal :active.sync="isImageModalActive" :width="640" scroll="keep">
      <div class="modal-card" style="width: auto">
        <section class="modal-card-body">
          <firebase-img :src="imageToDisplay" />
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'SoleModularOrders',
  props: ['mod', 'availablefogge', 'availablesoles', 'availablebatt', 'disabledbool', 'order'],
  inject: ['$validator'],
  data() {
    return {
      asImage: null,
      foggiaId: null,
      addingChar: null,
      isImageModalActive: false,
      imageToDisplay: null,
      soleId: null,
    }
  },
  watch: {
    foggiaId(newVal, oldVal) {
      if (oldVal !== null && newVal !== oldVal) {
        if (this.mod.sole && this.mod.sole.foggia && this.mod.sole.foggia.id === newVal) {
          return
        }
        this.soleId = null
        this.addingChar = null
      }
    },
  },
  computed: {
    // soles() {
    //   const defaultSole = this.mod.soles.filter(sole => sole.id === this.mod.sole_default)
    //   return !this.asImage ? this.mod.soles : defaultSole
    // },
    solesByFoggia() {
      return this.availablesoles.filter(sole => {
        return sole.foggia.id === this.foggiaId
      })
    },
    treadTypes() {
      const treadTypesList = this.solesByFoggia.map(sole => {
        if (!sole.tread.id) {
          sole.tread = { id: 'noTread', key: 'noTread -' + sole.id, commercial_name: this.$translate('printed_sole') }
        }
        return sole.tread
      })
      return Array.from(new Map(treadTypesList.map(tread => [tread.id, tread])).values())
    },
    solesByTread() {
      if (this.mod.soles) {
        return this.treadTypes.reduce((acc, treadType) => {
          acc[treadType.commercial_name] = {
            image: treadType.variants ? treadType.variants[0].image : '',
            soles: this.solesByFoggia.filter(sole => sole.tread.id === treadType.id),
          }
          return acc
        }, {})
      } else {
        return {}
      }
    },
    imageFoggia() {
      const selectedFoggia = this.availablefogge.find(foggia => foggia.id === this.foggiaId)
      return selectedFoggia ? selectedFoggia.variants[0].image : 'https://place-hold.it/150x75'
    },
    foggiaOptionalTagOptions() {
      const selectedFoggia = this.availablefogge.find(foggia => foggia.id === this.foggiaId)
      if (!selectedFoggia || !selectedFoggia.optional_tag) return []
      return selectedFoggia.optional_tag.map(tag => tag.key)
    },
  },
  methods: {
    updateAfterLoad() {
      if (this.mod.sole) {
        this.foggiaId = this.mod.sole && this.mod.sole.foggia ? this.mod.sole.foggia.id : null
        this.soleId = this.mod.sole.id
        this.addingChar = this.mod.sole.addingChar
        if (this.mod.sole.id === this.mod.sole_default) {
          this.asImage = true
        }
      }
    },
    updateSole(sole) {
      this.asImage = false
      this.addingChar = sole.addingChar || null
      this.soleId = sole.id || null
      if (!sole.foggia) this.foggiaId = null
      this.$emit('onUpdateSole', sole)
      // this.$emit('update', this.order)
      // this.$forceUpdate()
    },
    showImageModal(img) {
      this.isImageModalActive = true
      this.imageToDisplay = img
    },
    setDefaultSole() {
      if (this.asImage) {
        this.soleId = this.mod.sole_default
        const sole = this.availablesoles.find(s => s.id === this.soleId)
        this.addingChar = sole.addingChar
        this.foggiaId = sole && sole.foggia ? sole.foggia.id : null
        this.$emit('onUpdateSole', sole)
      } else {
        this.soleId = null
        this.addingChar = null
        this.foggiaId = null
        this.$emit('onUpdateSole', {})
      }
    },
    resetAsImage() {
      this.asImage = null
      this.foggiaId = null
      this.addingChar = null
      this.imageToDisplay = null
      this.soleId = null
    },
  },
}
</script>
<style scoped>
.container >>> .column select {
  min-width: 200px;
}
.container >>> textarea {
  resize: none;
}
.multiselect-list {
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  min-width: 200px;
  min-height: 120px;
  max-height: 200px;
  overflow-y: auto;
  background: white;
}
.multiselect-list.is-disabled {
  background-color: #f5f5f5;
  pointer-events: none;
}
.multiselect-option {
  padding: 0.35rem 0.75rem;
  white-space: normal;
  line-height: 1.4;
}
.multiselect-option.is-selected {
  background-color: #3273dc;
  color: white;
}
.multiselect-placeholder {
  display: block;
  padding: 0.35rem 0.75rem;
}
</style>
